export default {

    state: {

        defect: 'Mein Artikel ist defekt',

        incomplete: 'Meine Bestellung ist nicht vollständig',

        notcorrect: 'Mein Artikel weicht ab',

        notrecieved: 'Ich habe meine Bestellung nicht erhalten',

        revocation: 'Ich möchte meine Bestellung zurück geben',

        other: 'Ich habe eine andere Frage / Sonstiges'

    },

    getters: {
        getReasons: state => state
    }

}